import React, { Component } from 'react';
import { Form, Input, Grid, Button, } from 'semantic-ui-react'
import { authContext } from '../../adalConfig';
import { connect } from 'react-redux';
import { authAxios } from '../../utils';
import { GetEmployeeInformationURL, GetAllOfficeListingPointOfContactEmeaURL, InsertPatchEmployeeAsyncURL } from '../../constants';
import ProHeader from '../Pro/ProHeader';
import ProFooter from '../Pro/ProFooter';
import RHHeader from '../Corp/RHHeader';
import RHFooter from '../Corp/RHFooter';
import RHHeaderField from '../Field/RHHeaderField';
import { translationsV2 } from '../../translations';


let loginNameWithDomain = authContext.getCachedUser() ? authContext.getCachedUser().profile.upn : '';
let name = authContext.getCachedUser() ? authContext.getCachedUser().profile.name : '';


class EmeaUserInformation extends Component {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleGoToHelp = this.handleGoToHelp.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleHeaderSelection = this.handleHeaderSelection.bind(this);
        this.handleFooterSelection = this.handleFooterSelection.bind(this);

    }

    state = {
        key: '',
        name: '',
        email: '',
        country: '',
        city: '',
        error: false,
        userRole: '',
        region: '',
        translations: {},
        citiesCostCenters: [],
        deliveryOffice: '',
        officeListingPointOfContact: {},
    }

    updateOfficeListingCostCenterOptions(source) {
        if (this.state.userRole === 'PROTIVITI') {
            let sink = source.map((x, index) => {

                return ({
                    key: x.city,
                    text:  x.city,
                    value: x.city,
                })

            });
            return sink;
        }
        else{
            let sink = source.map((x, index) => {
                return ({
                    key: x.city,
                    text: x.city,
                    value: x.city,
                })
            });
            return sink;
        }
    }

    componentDidMount() {
        this.setState({
            loading: true
        })
        if (!loginNameWithDomain) {
            this.props.history.push('./unauthorized');
            return;
        }
        authAxios.post(GetEmployeeInformationURL, {
            LoginNameWithDomain: loginNameWithDomain
        })
        .then(response => {
            let data = response.data;
            this.setState({
                email: data.email, name: data.name,
                deliveryOffice: data.deliveryOffice,
                homeOffice: data.homeOffice,
                key: data.key,
                softwarePackages: data.softwarePackages,
                country: data.country,
                userRole: data.userRole,
                region: data.region,
                city: data.city,
                officeListingPointOfContact: data.officeListingPointOfContact,
            });
            if (this.state.region === 'NA') {
                this.props.history.push('./userinformation')
            }

            const country = this.state.country;

            let translations = this.getTranslationsBasedOnCountry(country);
            if (translations) {
                this.setState({
                    translations: translations
                });
            }
            authAxios.get(GetAllOfficeListingPointOfContactEmeaURL + `?role=${this.state.userRole}&country=${this.state.country}` )
                .then(response => {
                    let data = response.data

                    let citiesCostCenters = data.map((s, i) => ({ city: s.city, costCenter: s.costCenter, country: s.country })).filter(_ => _.city && _.costCenter && _.country);
                    citiesCostCenters.filter((v, i, a) => a.findIndex(t => (JSON.stringify(t) === JSON.stringify(v))) === i)

                    this.setState({
                        citiesCostCenters: this.updateOfficeListingCostCenterOptions(citiesCostCenters),
                    });

                    let costCenterFromEmployeeDeliveryOffice = this.state.citiesCostCenters.filter(_ => _.key === this.state.deliveryOffice);
                    if (costCenterFromEmployeeDeliveryOffice.length > 0) {
                        this.setState({
                            deliveryOffice: costCenterFromEmployeeDeliveryOffice[0].value
                        })
                    }
                    else {
                        this.setState({
                            deliveryOffice: null
                        })
                    }

                    if (this.state.userRole === 'PROTIVITI') {
                        this.state.citiesCostCenters.sort((a, b) => (a.text.substring(7) > b.text.substring(7)) ? 1 : -1);
                    }
                    else if (this.state.userRole === 'CORPORATE') {
                        this.state.citiesCostCenters.sort((a, b) => (a.text.substring(7) > b.text.substring(7)) ? 1 : -1);
                    }
                    else if (this.state.userRole === 'FIELD') {
                        this.state.citiesCostCenters.sort((a, b) => (a.text.substring(7) > b.text.substring(7)) ? 1 : -1);
                    }

                    if (this.state.deliveryOffice == null) {
                        let office = this.state.citiesCostCenters.filter(_ => _.key === this.state.officeListingPointOfContact.city);
                        if (office.length > 0) {
                            this.setState({
                                deliveryOffice: office[0].value
                            })
                        }
                    }
                    this.setState({
                        loading: false
                    });
                }, error => {
                    console.log(error);
                    this.setState({
                        loading: false
                    });
                });
                
        })
        .catch ((error) => {
            console.log('error ' + error);
            this.setState({
                errorredirect: true
            });
            this.setState({
                loading: false
            })
            this.props.history.push('./unauthorized');
        });
    }

    getTranslationsBasedOnCountry(country) {
        const translations = translationsV2.find(t => t.language === country);
        if (translations) {
            return translations.translations;
        }
        return translationsV2.find(t => t.country === "United States").translations;
    }
    
    handleClick = async () => {
        if (this.state.deliveryOffice && this.state.country) {
            //if (this.state.deliveryOffice !== 'Remote/Home Location' && this.state.userRole === 'PROTIVITI') {
            //    this.state.deliveryOffice = this.state.deliveryOffice.split("-")[0].split(")")[1].trim(); // Example "New York - 11111", take only New York and remove whitespace at the end of string New York
            //}
            //if (this.state.deliveryOffice !== 'Remote/Home Location' && this.state.userRole === 'FIELD') {
            //    this.state.deliveryOffice = this.state.deliveryOffice.split("-")[0].split(")")[1].trim();
            }

            let empDTO = {
                email: this.state.email, name: this.state.name, deliveryOffice: this.state.deliveryOffice, loginNameWithDomain: loginNameWithDomain,
                loginName: loginNameWithDomain.split('@').length > 1 ? loginNameWithDomain.split('@')[0] : '',
                homeOffice: this.state.city, country: this.state.country, softwarePackages: this.state.softwarePackages, CubicleNumber: this.state.CubicleNumber,
                UserComments: btoa(this.state.userComments), officeListingPointOfContact: this.state.officeListingPointOfContact,
            }
            let results = [];
            for (const property in empDTO) {
                results.push({
                    "op": "replace",
                    "path": `${property}`,
                    "value": `${empDTO[property]}`
                })
            }
            authAxios.patch(InsertPatchEmployeeAsyncURL + this.state.key,
                results
            )
                .then(response => {
                    console.log(response)
                    if (this.state.userRole === 'PROTIVITI')
                        this.props.history.push('./selection');

                    else if (this.state.userRole === 'CORPORATE')
                        this.props.history.push('./selectioncorp')

                    else if (this.state.userRole === 'FIELD')
                        this.props.history.push('./selectionfield')
                })
                .catch((error) => {
                    console.log('error: ' + error);
                });
        //} else {
        //    this.setState({ error: true });
        //}
    }

    handleGoToHelp() {
        this.props.history.push('./help');
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleDeliveryOfficeChange = (e, { value }) => {
        this.setState({
            deliveryOffice: value,
            error: false
        })
    }

    handleHomeOfficeChange = (e, { value }) => {
        this.setState({
            homeOffice: value,
            error: false
        })
    }

    handleHeaderSelection() {
        if (this.state.userRole === 'PROTIVITI')
            return <ProHeader />;
        else if (this.state.userRole === 'CORPORATE')
            return <RHHeader />;
        else if (this.state.userRole === 'FIELD')
            return <RHHeaderField />;
    }

    handleFooterSelection() {
        if (this.state.userRole === 'PROTIVITI')
            return <ProFooter />;
        else if (this.state.userRole === 'CORPORATE')
            return <RHFooter />;
        else if (this.state.userRole === 'FIELD')
            return <RHFooter />;
    }

    render() {

        const { name, email, deliveryOffice, citiesCostCenters } = this.state;
        return (
            <div className='outer-container'>
                <div className='inner-container'>
                    {this.handleHeaderSelection()}
                    <h1 className="headerclass">{this.state.translations.upDETitle}</h1>

                    <Form id="form_id" name="form" >

                        <Grid columns={2}>
                            <Grid.Row>
                                <Grid.Column stretched className="leftcolumn">
                                    <Form.Field inline className="leftforms">
                                        <label>{this.state.translations.nameLabel}: </label>
                                        <Input name={this.state.translations.Name} className='inputWidth' value={name} readOnly onChange={(e) => this.handleChange(e)} />
                                    </Form.Field>
                                    <Form.Field inline className="leftforms">
                                        <label>{this.state.translations.emailLabel}: </label>
                                        <Input name='email' className='inputWidth' value={email} readOnly onChange={(e) => this.handleChange(e)} />
                                    </Form.Field>
                                </Grid.Column>

                                <Grid.Column stretched className="rightforms">

                                    <Form.Field inline className="dropdown3">
                                        <label>{this.state.translations.country}: </label>
                                        <Input name='crountry' className='dropdown2' value={this.state.country} readOnly onChange={(e) => this.handleChange(e)} />
                                    </Form.Field>
                                    <Form.Field inline className="dropdown3">
                                        <label>{this.state.translations.homeOffice}: </label>
                                        <Input name='home office' className='dropdown2' value={this.state.city} readOnly onChange={(e) => this.handleHomeOfficeChange(e)} />
                                    </Form.Field>

                                    <Form.Dropdown
                                        defaultValue={this.state.deliveryOffice}
                                        inline
                                        label={this.state.translations.deliveryLabel}
                                        selection
                                        className='dropdown2'
                                        name='homeOffice'
                                        value={deliveryOffice}
                                        options={citiesCostCenters}
                                        onChange={this.handleDeliveryOfficeChange}
                                        error={this.state.error}
                                        search
                                        required
                                    />

                                </Grid.Column>
                            </Grid.Row>
                        </Grid>

                        <Grid centered>
                            <Grid.Row>
                                <Button color="green" type="submit" className="nextbuttonuser" onClick={this.handleClick} onSubmit={this.handle}
                                    disabled={!this.state.deliveryOffice}
                                > {this.state.translations.buttonNextText} <i class="right arrow icon"></i></Button>
                            </Grid.Row>
                        </Grid>

                    </Form>

                </div>
                {this.handleFooterSelection()}
            </div>

        );
    }

}

export default connect()(EmeaUserInformation);
